import Unit from '@/domain/model/unit/Unit.ts';

export default class Percentage extends Unit {
  private constructor(percentage: number) {
    super(percentage);
  }

  static of(percentage: number): Percentage {
    return new Percentage(percentage);
  }

  static ofRatio(ratio: number): Percentage {
    return new Percentage(ratio * 100);
  }

  asPercentage() {
    return Number(this.getValue());
  }

  subtractPercentage(otherPercentage: Percentage): Percentage {
    return new Percentage(this.asPercentage() - otherPercentage.asPercentage());
  }

  addPercentage(otherPercentage: Percentage): Percentage {
    return new Percentage(this.asPercentage() + otherPercentage.asPercentage());
  }

  asRatio(): number {
    return this.getValue() / 100;
  }

  format() {
    return this.getValue();
  }

  unit() {
    return '%';
  }

  times(scalar: number): Percentage {
    return new Percentage(this.asPercentage() * scalar);
  }

  toString(): string {
    return `${Math.round(this.getValue())}${this.unit()}`;
  }
}
